
import { useState, useEffect, useRef, memo } from 'react';
import Plyr from 'plyr-react';
import 'plyr-react/plyr.css';
import Hls from 'hls.js';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

const PlayStream = memo(({ title, poster, src }) => {  
  const ref = useRef(null);
  const plyrProps = {
    source: {
      type: 'video',
      title: title,
      poster: poster
    },
    options: {
      autoplay: true,
      hideControls: true,
      playsinline: true,
      disableContextMenu: true,
      speed: { selected: 1, options: [0.75, 1, 1.25] },
      controls: [
        'play-large', // The large play button in the center
        // 'rewind', // Rewind by the seek time (default 10 seconds)
        'play', // Play/pause playback
        // 'fast-forward', // Fast forward by the seek time (default 10 seconds)
        // 'progress', // The progress bar and scrubber for playback and buffering
        // 'current-time', // The current time of playback
        // 'duration', // The full duration of the media
        'mute', // Toggle mute
        'volume', // Volume control
        'captions', // Toggle captions
        'settings', // Settings menu
        'pip', // Picture-in-picture (currently Safari only)
        'airplay', // Airplay (currently Safari only)
        // 'download', // Show a download button with a link to either the current source or a custom URL you specify in your options
        'fullscreen' // Toggle fullscreen
      ]
    }
  };

  useEffect(() => {
    const loadVideo = async () => {
      const video = document.getElementById('plyr') || '';
      const hls = new Hls();
      hls.loadSource(src);
      hls.attachMedia(video);
      // @ts-ignore
      ref.current.plyr.media = video;

      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        ref.current.plyr.play();
      });
    };
    loadVideo();
    
  });

  return (
    <>
      <Plyr id="plyr" source={plyrProps.source} options={plyrProps.options} ref={ref} />
    </>
  );
});

export default PlayStream;